<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="35%"
  >
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="产品类型:" prop="productType">
        <el-select
          v-model="data.productType"
          placeholder="请选择产品类型"
          filterable
          clearable
          style="width:100%"
        >
          <el-option
            v-for="dict in productTypeList"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="产品型号:" prop="productModel">
        <el-input v-model="data.productModel" :maxlength="100" placeholder="请输入产品型号" clearable />
      </el-form-item>
      <el-form-item label="用量:" prop="usage">
        <el-input
          v-model="data.usage"
          type="number"
          :maxlength="100"
          placeholder="请输入用量"
          clearable
        />
      </el-form-item>
      <el-form-item label="单位:" prop="usageUnit">
        <el-select v-model="data.usageUnit" placeholder="请选择单位" clearable style="width:100%">
          <el-option
            v-for="dict in usageUnitList"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input v-model="data.remark" :maxlength="100" placeholder="请输入备注" clearable />
      </el-form-item>
      <el-form-item label="质量问题" prop="qualityFlag">
        <el-radio-group v-model="data.qualityFlag">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="data.qualityFlag === '1'">
        <el-form-item label="问题体现:" prop="problemList">
          <el-select
            v-model="data.problemList"
            placeholder="请选择问题体现"
            clearable
            style="width:100%"
            multiple
          >
            <el-option
              v-for="dict in qualityProblemList"
              :key="dict.dictValue"
              :label="dict.dictLabel"
              :value="dict.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="问题产品数量:" prop="problemProductCount">
          <el-input
            v-model="data.problemProductCount"
            type="number"
            step="1"
            :maxlength="100"
            placeholder="请输入问题产品数量"
            clearable
          />
        </el-form-item>
        <el-form-item label="更换型号:" prop="changeProductModel">
          <el-input
            v-model="data.changeProductModel"
            :maxlength="100"
            placeholder="请输入更换型号"
            clearable
          />
        </el-form-item>
        <el-form-item label="更换数量:" prop="changeProductCount">
          <el-input
            v-model="data.changeProductCount"
            type="number"
            step="1"
            :maxlength="10"
            placeholder="请输入更换数量"
            clearable
          />
        </el-form-item>
        <el-form-item label="更换成本(元):" prop="changeCost">
          <el-input
            v-model="data.changeCost"
            type="number"
            :maxlength="100"
            placeholder="请输入更换成本"
            clearable
          />
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listSimpleAll } from "@/api/crm/customer";
import { amountFormat } from "@/utils/index";
import { saveAfterSaleProduct } from "@/api/crm/order";
import { mapState } from "vuex";
import { queryProductTypeList } from "@/api/crm/contract";
export default {
  name: "AddCustomerDialog",
  props: {},
  data() {
    return {
      visible: false,
      title: '',
      productTypeList: [], // 产品类型
      usageUnitList: [], // 单位
      qualityProblemList: [], // 问题体现
      seviceWayOptions: [], // 服务方式
      sewageTypeOptions: [], // 污水类型
      problemJudgeOptions: [],
      serviceTypeList: [
        {
          // 服务类型
          dictLabel: "线上",
          dictValue: "1"
        },
        {
          dictLabel: "线下",
          dictValue: "2"
        }
      ],
      data: {
        productType: null,
        productModel: null,
        usage: null,
        usageUnit: null,
        remark: '',
        problemList: [],
        qualityFlag: "1",
        sewageTypeList: [],
        changeProductModel: null,
        problemProductCount: null,
        changeProductCount: null,
        changeCost: null,
        dailyProcessCapacity: null
      },
      rules: {
        productType: [
          { required: true, message: "请选择产品类型", trigger: "change" }
        ],
        // productModel: [
        //   { required: true, message: "请输入产品型号", trigger: "change" }
        // ],
        problemProductCount: [
          { required: true, message: "请输入问题产品数量", trigger: "change" }
        ],
        problemList: [
          { required: true, message: "请选择问题体现", trigger: "change" }
        ],
        changeProductModel: [
          { required: true, message: "请输入更换型号", trigger: "change" }
        ],
        usage: [{ required: true, message: "请输入用量", trigger: "change" }],
        usageUnit: [
          { required: true, message: "请选择单位", trigger: "change" }
        ],
        qualityFlag: [{ required: true, message: "请选择", trigger: "change" }]
      }
    };
  },
  created() {
    listSimpleAll().then(response => {
      this.customerList = response.data;
    });
    this.getDicts("usage_unit").then(response => {
      this.usageUnitList = response.data;
    });
    this.getDicts("quality_problem").then(response => {
      this.qualityProblemList = response.data;
    });
    this.queryProductTypeList();
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {},
  watch: {
    visible(val) {
      if (!val) {
        this.data.problemPicList = [];
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open(id, data) {
      this.data.serviceOrderId = id;
      if(data.id){
        this.data = data;
        this.title = '编辑售后产品'
        this.data.qualityFlag = data.qualityFlag.toString()
      }else{
        this.title = '新增售后产品'
        this.data.qualityFlag = '1'
      }
      this.visible = true;
    },
    queryProductTypeList() {
      queryProductTypeList({}).then(response => {
        const { code, msg, data } = response;
        if (code == 200) {
          this.productTypeList = data || [];
        }
      });
    },
    customerChange(customerId) {
      this.deliveryList = [];
      this.data.deliveryOrderId = null;
      if (customerId) {
        listDeliveryByPage({ customerId: customerId }).then(response => {
          this.deliveryList = response.rows || [];
        });
      }
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          saveAfterSaleProduct(this.data)
            .then(response => {
              this.$emit("success");
              this.visible = false;
              loading.close();
              this.msgSuccess("新增成功");
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
